import styled from 'styled-components'
import ReactPlayer from 'react-player'
import useGetElementWidth from 'hooks/useGetElementWidth'
// import useGetMetadataId from 'hooks/useGetMetadataId'
import { BsFillPlayFill } from 'react-icons/bs'

const Videoplayer = ({ id, links }: { id: string; links?: string[] }) => {
  const [elementRef, width] = useGetElementWidth()
  const height = (width * 9) / 16
  // const storyId = useGetMetadataId()
  // const item = data?.data.find((item: any) => item['metadata id'] === storyId)
  // const youtubeId = item ? item['Youtube ID'] : ''

  const service_links = links?.map((l) => {
    const link = l.split(']')
    return {
      name: link[0].replace('[', ''),
      url: link[1],
    }
  })

  return (
    <Container>
      {id && (
        <ContentWidth ref={elementRef}>
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${id}`}
            width={width}
            height={height}
            controls
          />
        </ContentWidth>
      )}
      <TextWidth>
        <div style={{ margin: '0 2rem' }}>
          {service_links?.map(function (link: any, index: number) {
            return (
              <Link
                className='item'
                href={link.url}
                target='_blank'
                key={'link-' + index}
                rel='noreferrer'
              >
                <BsFillPlayFill />
                {link.name}
              </Link>
            )
          })}
        </div>
      </TextWidth>
    </Container>
  )
}

export default Videoplayer

const Container = styled.div`
  margin-bottom: 40px;
`

const ContentWidth = styled.div`
  margin: 0 auto;
  max-width: 960px;
`

const Link = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.secondaryButtonText};
  background: ${({ theme }) => theme.secondaryButtonBackground};
  text-decoration: none;
  font-family: var(--font-plex);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
`

const TextWidth = styled.div`
  margin: 0 auto;
  max-width: 666px;
  font-family: var(--font-plex);
  margin-top: 20px;
  font-size: 0.85em;
`
